import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-rowspan-cell',
    template: `<span>{{ value }}</span>`,
    styles: [`
    :host {
      display: table-cell;
      vertical-align: middle;
    }
  `],
    standalone: true
})
export class RowspanCellComponent implements ICellRendererAngularComp {
  public value: any;

  agInit(params: any): void {
    this.value = params.value;
  }

  refresh(params: any): boolean {
    return false;
  }
}